import React, { Fragment, useEffect, useState } from 'react';
import {css, Global, keyframes} from '@emotion/react';
import {BrowserRouter as Router, Switch, Route, Redirect, useHistory, Link} from 'react-router-dom';

export default ({children}) => {
  const history = useHistory();
  useEffect(() => {
    const token = sessionStorage.getItem('USR');
    if (!token) history.push('/login');
  }, []);
  return children;
};
